<template>
  <b-tab title="Produtos" class="m-0 p-0">
    <div class="tab-screen-list">
      <!-- :::::::::::::::::::::::::::: TABELA DE PRODUTOS :::::::::::::::::::::::::::: -->
      <b-table bordered hover small head-variant="light" :items="getFilterProdutos(filtro)" :fields="fields.produto">
        <template #cell(valor)="data">
          <div>
            <p>{{ formatter.format(data.item.valor) }}</p>
          </div>
        </template>

        <template #cell(acoes)="data">
          <div>
            <b-button class="pt-0 pb-0" variant="link" @click="editar(data.item)" v-b-tooltip.hover title="Editar">
              <b-icon icon="pencil-square" variant="primary"> </b-icon>
            </b-button>
            <b-button class="pt-0 pb-0" variant="link" @click="display(data.item)" v-b-tooltip.hover title="Imagem">
              <b-icon icon="image" variant="info"> </b-icon>
            </b-button>
          </div>
        </template>
      </b-table>
    </div>
    <!-- :::::::::::::::::::::::::::: BARRA DE AÇÕES :::::::::::::::::::::::::::: -->
    <div class="menu-acoes pb-2">
      <div id="search-bar">
        <b-col cols="10" class="p-1 pr-0">
          <b-form inline>
            <b-button size="sm" class="pl-2 pr-3" variant="info" @click="adicionar()">
              <b-icon icon="plus-circle" variant="light" scale="1.1" class="mr-2" />Adicionar
            </b-button>
            <b-form-input
              id="produto-filter-codigo"
              type="search"
              size="sm"
              class="m-1 p-1"
              placeholder="Filtre pelo código."
              v-model="filtro.codigo"
            />
            <b-form-input
              id="produto-filter-descricao"
              type="search"
              size="sm"
              class="m-1 p-1"
              placeholder="Filtre pela descrição."
              v-model="filtro.descricao"
            />
            <b-icon icon="search" variant="light" scale="1.2" class="m-1" />
          </b-form>
        </b-col>
      </div>
    </div>
    <!-- :::::::::::::::::::::::::::: MODAL DE EDIÇÃO :::::::::::::::::::::::::::: -->
    <produto-modal ref="editor" />
    <display-modal ref="display" :size="'lx'" />
  </b-tab>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { storeToRefs } from "pinia";
import { useProdutoStore } from "@/stores/ProdutoStore";
import Produto from "@/models/Produto";
import TableFields from "@/tools/TableFields";
import ProdutoModal from "@/components/modals/orcamento/ProdutoModal";
import DisplayModal from "@/components/modals/diversos/DisplayModal";
import Files from "@/http/files";

export default {
  name: "ProdutoTabList",

  data() {
    return {
      fields: new TableFields(),
      filtro: { codigo: "", descricao: "" },
      files: new Files(this.$http),
      formatter: new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
      }),
    };
  },

  components: {
    "produto-modal": ProdutoModal,
    "display-modal": DisplayModal,
  },

  methods: {
    adicionar() {
      this.$refs.editor.call(new Produto(0, "Novo produto", "", "", 0.0, "", ""));
    },

    editar(produto) {
      this.$refs.editor.call(produto);
    },

    display(produto) {
      this.files.downloadProduto(produto.id).then((response) => this.$refs.display.call(response));
    },
  },

  setup() {
    const store = useSgcqStore();
    const produtoStore = useProdutoStore();
    const { getFilterProdutos } = storeToRefs(produtoStore);

    return {
      store,
      produtoStore,
      getFilterProdutos,
    };
  },
};
</script>

<style lang="scss" scoped>
#produto-filter-codigo {
  width: 15rem;
}
#produto-filter-descricao {
  width: 30rem;
}
.menu-acoes {
  background-color: #112a4a;
}
</style>
